import { siteDataService } from "../services/siteDataService";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { fetchSiteData } from "../redux/slices/siteDataSlice";

type Filters = Record<string, any>;

export function useSiteData(_filters: Filters = {}) {
  // const {  isLoading, error, mutate } = useSWR(["/site-data", filters], () => siteDataService.getSiteData(filters))
  const { siteData, currentSiteData } = useAppSelector(
    (state) => state.siteData,
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!siteData) {
      dispatch(fetchSiteData());
    }
  }, [siteData, dispatch]);

  async function getById(id: string) {
    return siteDataService.getSiteDataById(id);
  }

  async function getByProject(projectId: string, moreFilters: Filters = {}) {
    return siteDataService.getSiteDataByProject(projectId, moreFilters);
  }

  async function create(payload: any) {
    const res = await siteDataService.createSiteData(payload);
    // await mutate()
    return res;
  }

  async function update(id: string, payload: any) {
    const res = await siteDataService.updateSiteData(id, payload);
    // await mutate()
    return res;
  }

  async function remove(id: string) {
    const res = await siteDataService.deleteSiteData(id);
    // await mutate()
    return res;
  }

  async function bulkCreate(siteDataArray: any[]) {
    const res = await siteDataService.bulkCreateSiteData(siteDataArray);
    // await mutate()
    return res;
  }

  async function exportForProject(
    projectId: string,
    format: "csv" | "json" = "csv",
  ) {
    return siteDataService.exportSiteData(projectId, format);
  }
  return {
    siteData: siteData ?? [],
    currentSiteData,

    getById,
    getByProject,
    create,
    update,
    remove,
    bulkCreate,
    exportForProject,
  };
}
